module.exports = __webpack_public_path__ + "img/20180815_154807_252.1f15d370.jpg";